import React from 'react';
import { CalendarClock, Wallet } from 'lucide-react';

const eur = (v) => `${(v || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
const dateFr = (d) => (d && d.length >= 10 ? `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}` : '—');

export const SoldeDuLigne = ({ solde }) => {
  if (!solde) return null;
  const p = solde.prochaine_echeance;
  return (
    <div className="flex flex-wrap items-center gap-x-5 gap-y-1 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm" data-testid={`solde-du-${solde.souscription_id}`}>
      <span className="flex items-center gap-1.5 text-amber-900 font-semibold">
        <Wallet className="h-4 w-4" />Reste dû : <span data-testid={`solde-du-reste-${solde.souscription_id}`}>{eur(solde.reste)}</span>
      </span>
      <span className="text-amber-800 text-xs">Payé {eur(solde.paye)} sur {eur(solde.total)}{solde.reference ? ` — ${solde.reference}` : ''}</span>
      <span className="flex items-center gap-1.5 text-amber-900 text-xs" data-testid={`solde-du-echeance-${solde.souscription_id}`}>
        <CalendarClock className="h-4 w-4" />
        {p ? `Prochaine échéance : ${dateFr(p.date)}${p.montant ? ` (${eur(p.montant)})` : ''}` : 'Aucune échéance programmée'}
      </span>
    </div>
  );
};

export const SoldesDusSection = ({ soldes }) => {
  if (!soldes?.length) return null;
  return (
    <div className="space-y-2" data-testid="soldes-dus-section">
      {soldes.map((s) => <SoldeDuLigne key={s.souscription_id} solde={s} />)}
    </div>
  );
};
